import {Component, Input} from '@angular/core';
import {GlobalService} from '../../services/global/global.service';

@Component({
  selector: 'app-loading',
  templateUrl: 'loading.component.html',
  styleUrls: ['loading.component.css'],
})
export class LoadingComponent {
  @Input() public loading: boolean;
}
